<template>
    <div class="ck-config-item">
        <el-card class="mb16" shadow="never">
            <div class="ck-config-data">
                <el-descriptions class="margin-top" :column="1" border size="small">    
                     <el-descriptions-item label="Cookie名称" label-class-name="ck-config-label" content-class-name="ck-config-value">
                        <div class="cookie-name">{{ ckConfigData.config.ck_name }}</div>
                    </el-descriptions-item>                  
                    <el-descriptions-item label="Cookie值" label-class-name="ck-config-label" content-class-name="ck-config-value">
                        <div class="cookie-val">{{ ckConfigData.config.ck_value }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="是否启用" label-class-name="ck-config-label">
                        <el-tag size="small" :type="ckConfigData.config.ck_status == 1 ? 'success' : 'danger'" >{{ckConfigData.config.ck_status_text}}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="是否失效" label-class-name="ck-config-label">
                        <el-tag size="small" :type="ckConfigData.config.ck_valid == 0 ? 'danger' : 'success'">{{ckConfigData.config.ck_valid_text}}</el-tag>
                    </el-descriptions-item>                       
                </el-descriptions>

            </div>
            <div class="btn-box mt20">
                <el-button type="primary" @click="getData" :loading="ckConfigData.loading" :disabled="!ckConfigData.config.ck_value" size="small">检查是否失效</el-button>
                
                <el-button type="primary" @click="openCKConfig"  size="small">编 辑</el-button>
                <el-button type="danger" @click="deleteCKConfig"  size="small">删 除</el-button>
            </div>
        </el-card> 
    </div>
</template>
<script>
    export default {
        name: 'CKConfigItem',
        props: {
            ckConfig: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                ckConfigData: {
                    loading: false,
                    config: {},
                    ck_list: []
                }
            }
        },

        methods: {
            getData(){               
               this.ckConfigData.loading = true;
               this.$api.checkCkValid({
                    ck_value:this.ckConfigData.config.ck_value,
                    ck_id:this.ckConfigData.config.id,
               }).then(res=>{
                    this.ckConfigData.loading = false
                    this.ckConfigData.config.ck_valid = res.data.ck_valid
                    this.ckConfigData.config.ck_valid_text = res.data.ck_valid_text
               }).catch(e=>{
                   this.ckConfigData.loading = false
               })
           },
           openCKConfig(){
               this.$emit('openCKConfig',this.ckConfigData.config)
           },
           deleteCKConfig(){
               this.$emit('deleteCKConfig',this.ckConfigData.config)
           }
        },
        watch: {
            ckConfig: {
                handler(val) {
                    this.ckConfigData.config = val
                },
                deep: true,
                immediate: true,
            }
        }
    }
</script>
<style lang="scss">
    .ck-config-item{
        .ck-config-label{
            background: #f5f7fa;
            color: #606266;
            font-weight: 700; 
            width: 120px;          
        }
        .ck-config-value{
            font-family: monospace;
            .cookie-val{
                // padding: 8px 12px;
                white-space: pre-wrap;
                word-break: break-all;
                border-radius: 4px;                
                border: 1px solid #ebeef5;
                background-color: #fafafa;
            }
        }
    }
        
</style>